import { createContext } from "react";

interface LocationContextValue {
  location?: any;
}

const LocationContext = createContext<LocationContextValue>({});

export default LocationContext;
